import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import styles from "./UseCheckList.module.css";
import PageContainer from "../layout/PageContainer";
import { Checkbox, Divider, Row, Space } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

type TypeUseCategoryItem = {
    [key: string]: { name: string; items: Array<TypeUseItem> };
};

type TypeUseItem = {
    isChecked: boolean;
    name: string;
};

const UseItemList: TypeUseCategoryItem = {
    camping: {
        name: "캠핑 세트",
        items: [
            {
                isChecked: false,
                name: "코펠 세트",
            },
            {
                isChecked: false,
                name: "삼성 플레이트 인덕션 1구",
            },
            {
                isChecked: false,
                name: "조리도구 세트",
            },
            {
                isChecked: false,
                name: "식칼(과도/식도)",
            },
            {
                isChecked: false,
                name: "일회용 식기(밥그릇4/국그릇4/접시2/수저8)",
            },
            {
                isChecked: false,
                name: "일회용 수세미 4장",
            },
            {
                isChecked: false,
                name: "주방 세제",
            },
            {
                isChecked: false,
                name: "쓰레기 봉투(10L)",
            },
            {
                isChecked: false,
                name: "어닝 고정 세트",
            },
            {
                isChecked: false,
                name: "팩망치",
            },
            {
                isChecked: false,
                name: "멀티탭 3구",
            },
            {
                isChecked: false,
                name: "모기약(리퀴드타입)",
            },
            {
                isChecked: false,
                name: "전기 파리채",
            },
        ],
    },
    bedclothes: {
        name: "침구 세트",
        items: [
            { isChecked: false, name: "사계절이불" },
            { isChecked: false, name: "여름이불" },
            { isChecked: false, name: "베개 2개" },
            { isChecked: false, name: "미니 베개 2개" },
            { isChecked: false, name: "토퍼" },
        ],
    },
};

function UseCheckList() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();
    const [rent, setRent] = useState<Types.RentDto>();

    const [useCheckItemList, setUseCheckItemList] = useState<TypeUseCategoryItem>();

    useEffect(() => {
        setUseCheckItemList(JSON.parse(JSON.stringify(UseItemList)));
    }, []);

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
    }, [params.rentId]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        currentRentId && requestGetRent();
        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        };
    }, [currentRentId]);

    const requestAxiosGetRent = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + currentRentId);
        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;
        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    useEffect(() => {
        if (rent === undefined) return;

        if (rent.rentPaidItems.length > 0) {
            const tempCheckItemList = { ...useCheckItemList };
            tempCheckItemList["paidItems"] = { name: "유료 대여 품목", items: [] };
            rent.rentPaidItems.forEach((item) => {
                tempCheckItemList["paidItems"].items.push({ isChecked: false, name: item.rentPaidItemName });
            });
            setUseCheckItemList(tempCheckItemList);
        }
    }, [rent]);

    const goToNextProcess = () => {
        // navigate(Common.PAGE_USE_ADDIMAGE + "/" + currentRentId);    // skip Add Image
        navigate(Common.PAGE_USE_EDUCATION + "/" + currentRentId);
    };

    const setCheckItem = (key: string, item: TypeUseItem, check: boolean) => {
        const tempCheckItemList = { ...useCheckItemList };
        const tempItems = tempCheckItemList[key].items;
        const temp = tempItems.find((temp) => temp.name === item.name);
        if (temp !== undefined) temp.isChecked = check;

        setUseCheckItemList(tempCheckItemList);
    };

    useEffect(() => {
        if (useCheckItemList === undefined) return;

        const unCheckedItem = Object.keys(useCheckItemList).find((category) => useCheckItemList[category].items.find((item) => item.isChecked === false));

        if (unCheckedItem === undefined) {
            Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);
        } else {
            Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, false);
        }
    }, [useCheckItemList]);

    const displayItems = () => {
        if (useCheckItemList === undefined) return null;

        return Object.keys(useCheckItemList).map((key, index) => {
            return (
                <div key={key}>
                    <Space key={key} direction="vertical" size={10} style={{ width: "100%" }}>
                        <h3 style={{ margin: 0 }}>{useCheckItemList[key].name}</h3>
                        {useCheckItemList[key].items.map((item) => (
                            <Row key={item.name}>
                                <Checkbox className={styles.checkbox} checked={item.isChecked} onChange={(e) => setCheckItem(key, item, e.target.checked)}>
                                    {item.name}
                                </Checkbox>
                            </Row>
                        ))}
                    </Space>
                    {index === Object.length ? "" : <Divider className={styles.divider} />}
                </div>
            );
        });
    };

    const onAllCheck = (check: boolean) => {
        const tempCheckItemList = { ...useCheckItemList };
        Object.keys(tempCheckItemList).forEach((key) => tempCheckItemList[key].items.forEach((item) => (item.isChecked = check)));

        setUseCheckItemList(tempCheckItemList);
    };

    return (
        <PageContainer>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <Checkbox className={styles.checkbox} style={{ fontSize: "18px", fontWeight: "bold" }} onChange={(e) => onAllCheck(e.target.checked)}>
                    전체선택
                </Checkbox>
                {displayItems()}
            </Space>
        </PageContainer>
    );
}

export default UseCheckList;
